import { FC } from "react";
import { Icon } from "./../../../../components";
import { useCalendar } from "./../../../../context/CalendarProvider";
import { useLanguage } from "./../../../../context/LocaleProvider";
import {
  NavigationWrapper,
  Wrapper,
  NavBtn,
  Today,
  Zoom,
  OptionsContainer,
  Title
} from "./styles";
import { TopbarProps } from "./types";
import dayjs from "dayjs";
import styles from "./styles.module.scss";

const Topbar: FC<TopbarProps> = ({ width, showThemeToggle, toggleTheme }) => {
  const { topbar } = useLanguage();
  const {
    data,
    handleGoNext,
    handleGoPrev,
    handleGoToday,
    zoomIn,
    zoomOut,
    zoomBiannual,
    zoomAnnual,
    zoom,
    date
  } = useCalendar();

  let displayMiddle;
  let beginDate = dayjs(date);
  let beginStringDate = beginDate.startOf('month').get('date') + "/" + (beginDate.month() +1) + "/" + beginDate.year();
  let endDate = dayjs(date);
  switch (zoom) {
    case 0:
      endDate = endDate.add(2, 'month');
      displayMiddle = beginStringDate + " até " + endDate.endOf('month').get('date') + "/" + (endDate.month() +1) + "/" + endDate.year();
      break;
    case 1:
      endDate = endDate;
      displayMiddle = beginStringDate + " até " + endDate.endOf('month').get('date') + "/" + (endDate.month() +1) + "/" + endDate.year();
      break;
    case 3:
      endDate = endDate.add(5, 'month');
      displayMiddle = beginStringDate + " até " + endDate.endOf('month').get('date') + "/" + (endDate.month() +1) + "/" + endDate.year();
      break;
    case 4:
      beginDate = beginDate.startOf('year');
      beginStringDate = beginDate.get('date') + "/" + (beginDate.month() +1) + "/" + beginDate.year();
      
      endDate = endDate.endOf('year');
      displayMiddle = beginStringDate + " até " + endDate.endOf('month').get('date') + "/" + (endDate.month() +1) + "/" + endDate.year();
      break;
    default:
      break;
  }

  return (
    <>
      <Wrapper width={width}>
        <Title>Mapa de Alocação</Title>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <NavigationWrapper>
            <NavBtn disabled={!data?.length} onClick={handleGoPrev}>
              <Icon iconName="arrowLeft" height="15" fill={"#781AA0"} />
              {topbar.prev}
            </NavBtn>
            <Today onClick={handleGoToday}>{displayMiddle}</Today>
            <NavBtn disabled={!data?.length} onClick={handleGoNext}>
              {topbar.next}
              <Icon iconName="arrowRight" height="15" fill={"#781AA0"} />
            </NavBtn>
          </NavigationWrapper>
        </div>
        <OptionsContainer>
          <Zoom className={styles.topbar}>
            {/* {topbar.view} */}
            <div className={styles.divButtons}>
              <button onClick={zoomAnnual} className={ zoom === 4 ? styles.activeButton : styles.nonActiveButton}>Anual</button>
              <button onClick={zoomBiannual} className={ zoom === 3 ? styles.activeButton : styles.nonActiveButton}>Semestral</button>
              <button onClick={zoomOut} className={ zoom === 0 ? styles.activeButton : styles.nonActiveButton}>Trimestral</button>
              <button onClick={zoomIn} className={ zoom === 1 ? styles.activeButton : styles.nonActiveButton}>Mensal</button>
            </div>
          </Zoom>
        </OptionsContainer>
      </Wrapper>
    </>
  );
};
export default Topbar;
